module.exports = __webpack_public_path__ + "img/manual-enem.65a2ee0d.png";